import { api } from 'src/services';
import getTournaments from './getTournaments';
import deleteTournament from './deleteTournament';
import addTournament from './addTournament';
import editTournament from './editTournament';
import getTournamentCategories from './getTournamentCategories';
import getTournamentDetails from './getTournamentDetails';
import getTournamentOrganizers from './getTournamentOrganizers';
import deleteOrganizer from './deleteOrganizer';
import searchUsers from './searchUsers';
import addOrganizer from './addOrganizer';
import deleteTeam from './deleteTeam';
import editTeam from './editTeam';
import getTeams from './getTournamentTeams';
import addTeam from './addTeam';
import getTournamentStandings from './getTournamentStandings';
import getTournamentSchedule from './getTournamentSchedule';
import editMatch from './editMatch';
import getTournamentKnockouts from './getTournamentKnockouts';
import exportTeams from './exportTeams';
import getTournamentWaitingList from './getTournamentWaitingList';
import acceptOrRejectWaitingListRequest from './acceptOrRejectWaitingListRequest';
import getOptions from './getOptions';
import generateTournamentSchedule from './generateTournamentSchedule';
import exportAllMatches from './exportAllMatches';
import swapMatchTeamsNames from './swapMatchTeamsNames';
import resetMatchScore from './resetMatchScore';
import getTargettedTeams from './getTargettedTeams';
import swapTeams from './swapTeams';
import resetCustomMatchScore from './resetCustomMatchScore';
import getTargettedTeamsToSeed from './getTargettedTeamsToSeed';
import seedMatch from './seedMatch';
import exportAllCustomMatches from './exportAllCustomMatches';
import addCustomMatch from './addCustomMatch';
import getMinimalTeams from './getMinimalTeams';
import editCustomMatch from './editCustomMatch';
import resetImage from './resetImage';
import updateTeamPosition from './updateTeamPosition';
import getTournamentPositions from './getTournamentPositions';
import getTournamentsWithoutPagination from './getTournamentsWithoutPagination';
import generateScheduleFromSheet from './generateScheduleFromSheet';
import clearSchedule from './clearSchedule';
import addTeamToSchedule from './addTeamToSchedule';
import getByeMatchesTeams from './getByeMatchesTeams';

export const tournamentsApis = api.injectEndpoints({
  endpoints: (build) => ({
    getTournaments: getTournaments(build),
    deleteTournament: deleteTournament(build),
    addTournament: addTournament(build),
    editTournament: editTournament(build),
    getTournamentCategories: getTournamentCategories(build),
    getTournamentDetails: getTournamentDetails(build),
    getTournamentOrganizers: getTournamentOrganizers(build),
    deleteOrganizer: deleteOrganizer(build),
    searchUsers: searchUsers(build),
    addOrganizer: addOrganizer(build),
    deleteTeam: deleteTeam(build),
    editTeam: editTeam(build),
    getTeams: getTeams(build),
    addTeam: addTeam(build),
    getTournamentStandings: getTournamentStandings(build),
    getTournamentSchedule: getTournamentSchedule(build),
    editMatch: editMatch(build),
    getTournamentKnockouts: getTournamentKnockouts(build),
    exportTeams: exportTeams(build),
    getTournamentWaitingList: getTournamentWaitingList(build),
    acceptOrRejectWaitingListRequest: acceptOrRejectWaitingListRequest(build),
    getOptions: getOptions(build),
    generateTournamentSchedule: generateTournamentSchedule(build),
    exportAllMatches: exportAllMatches(build),
    swapMatchTeamsNames: swapMatchTeamsNames(build),
    resetMatchScore: resetMatchScore(build),
    getTargettedTeams: getTargettedTeams(build),
    swapTeams: swapTeams(build),
    resetCustomMatchScore: resetCustomMatchScore(build),
    getTargettedTeamsToSeed: getTargettedTeamsToSeed(build),
    seedMatch: seedMatch(build),
    exportAllCustomMatches: exportAllCustomMatches(build),
    addCustomMatch: addCustomMatch(build),
    getMinimalTeams: getMinimalTeams(build),
    editCustomMatch: editCustomMatch(build),
    resetImage: resetImage(build),
    updateTeamPosition: updateTeamPosition(build),
    getTournamentPositions: getTournamentPositions(build),
    getTournamentsWithoutPagination: getTournamentsWithoutPagination(build),
    generateScheduleFromSheet: generateScheduleFromSheet(build),
    clearSchedule: clearSchedule(build),
    addTeamToSchedule: addTeamToSchedule(build),
    getByeMatchesTeams: getByeMatchesTeams(build),
  }),
  overrideExisting: true,
});

export const {
  useLazyGetTournamentsQuery,
  useDeleteTournamentMutation,
  useAddTournamentMutation,
  useEditTournamentMutation,
  useLazyGetTournamentCategoriesQuery,
  useLazyGetTournamentDetailsQuery,
  useLazyGetTournamentOrganizersQuery,
  useDeleteOrganizerMutation,
  useSearchUsersMutation,
  useAddOrganizerMutation,
  useDeleteTeamMutation,
  useEditTeamMutation,
  useLazyGetTeamsQuery,
  useAddTeamMutation,
  useLazyGetTournamentStandingsQuery,
  useLazyGetTournamentScheduleQuery,
  useEditMatchMutation,
  useLazyGetTournamentKnockoutsQuery,
  useExportTeamsMutation,
  useLazyGetTournamentWaitingListQuery,
  useAcceptOrRejectWaitingListRequestMutation,
  useLazyGetOptionsQuery,
  useGenerateTournamentScheduleMutation,
  useExportAllMatchesMutation,
  useSwapMatchTeamsNamesMutation,
  useResetMatchScoreMutation,
  useGetTargettedTeamsMutation,
  useSwapTeamsMutation,
  useResetCustomMatchScoreMutation,
  useGetTargettedTeamsToSeedMutation,
  useSeedMatchMutation,
  useExportAllCustomMatchesMutation,
  useAddCustomMatchMutation,
  useLazyGetMinimalTeamsQuery,
  useEditCustomMatchMutation,
  useResetImageMutation,
  useUpdateTeamPositionMutation,
  useLazyGetTournamentPositionsQuery,
  useLazyGetTournamentsWithoutPaginationQuery,
  useGenerateScheduleFromSheetMutation,
  useClearScheduleMutation,
  useAddTeamToScheduleMutation,
  useLazyGetByeMatchesTeamsQuery,
} = tournamentsApis;
